/**
 * @param {string} name
 * @param {*} data
 */
const saveFilters = (name, data) => {
  localStorage.setItem(name, JSON.stringify(data));
};

/**
 * @param {string} name
 * @returns {*}
 */
const getFilters = name => {
  const item = localStorage.getItem(name);
  if (item) {
    const {
      dateTypeFilterId = null,
      filters = {},
      params = {},
      period = null,
      userFilter
    } = JSON.parse(item);
    return { filters, params, userFilter, dateTypeFilterId, period };
  }
  return {
    filters: {},
    params: {}
  };
};

/**
 * @param {string} name
 * @param {*} data
 */
const savePreferences = (name, data) => {
  const previous = getPreferences(name);
  const newPreferences = {
    ...previous,
    ...data
  };
  localStorage.setItem(name, JSON.stringify(newPreferences));
};

/**
 * @param {string} name
 * @returns {*}
 */
const getPreferences = name => {
  const item = localStorage.getItem(name);
  return item ? JSON.parse(item) : {};
};

export { getFilters, getPreferences, saveFilters, savePreferences };
